import { Languages } from "../types";
import { companyCardDictionary } from "./companyCard";
import { shortcutsDictionary } from "./shortcuts";
import { DashboardPagesDescriptions } from "./types";

export const getDashboardDescriptions = (systemLang: Languages): DashboardPagesDescriptions => ({
    SHORTCUTS: shortcutsDictionary[systemLang],
    COMPANY_CARD: companyCardDictionary[systemLang],
})